<template>
  <div>
    <div class="box loginBox" v-if="showLogin == 1">
      <div class="title">
        <span class="t1">
          {{showPasswordLogin == false ? "公众号扫码登录":"登录"}}
        </span>
        <div class="t2" @click="closeLogin()">
          X
        </div>
      </div>
      <!-- 分割线 -->
      <el-divider></el-divider>

      <el-form :label-position="labelPosition" :rules="loginRules" :model="loginForm" ref="loginForm">
        <div class="passwordLogin" v-if="showPasswordLogin">
          <el-form-item label="手机号码或邮箱地址" prop="account">
            <el-input v-model="loginForm.account" placeholder="请输入手机号码或邮箱地址" :disabled="loginType.password"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" :disabled="loginType.password"><el-button plain @click="forgetPwd" slot="suffix" :disabled="loginType.password">忘记密码？</el-button></el-input>
          </el-form-item>
          <el-row class="btn">
            <el-button class="loginBtn" type="primary" @click="startLogin" :disabled="loginType.password">登录</el-button>
            <el-button class="registerBtn" type="info" @click="goRegister" :disabled="loginType.password">注册</el-button>
          </el-row>
        </div>

        <el-row class="elRow">
          <el-tooltip content="微信" placement="bottom">
            <el-button type="success" circle @click="goAuth('wechat')" :disabled="loginType.wechat">
              <span class="iconfont">&#xe66f;</span>
            </el-button>
          </el-tooltip>

          <el-tooltip content="QQ" placement="bottom">
            <el-button type="primary" circle @click="goAuth('qq')" :disabled="loginType.qq">
              <span class="iconfont">&#xe601;</span>
            </el-button>
          </el-tooltip>

        </el-row>
        <div class="loginTip">目前登录方式支持
          <span v-if="!loginType.password"> 账号密码 </span>
          <span v-if="!loginType.wechat"> 微信 </span>
          <span v-if="!loginType.qq"> QQ </span>
        </div>
      </el-form>

    </div>

    <el-dialog :width="dialogWidth" :visible.sync="regDialogFormVisible" :style="{'font-size': '22px', 'font-weight': 'bold'}" :before-close="closeRegBox" title="注册" :center="true" v-if="showLogin == 2">
      <el-form :rules="rules" :label-position="labelPosition" :model="registerForm" ref="registerForm">
        <el-form-item label="用户名（建议填写个人姓名）" prop="username">
          <el-input v-model="registerForm.username" placeholder="用户名长度在2~20之间" :disabled="loginType.password"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="registerForm.password" placeholder="密码长度在5~20之间" :disabled="loginType.password"></el-input>
        </el-form-item>

        <el-form-item label="重复密码" prop="password2">
          <el-input type="password" v-model="registerForm.password2" placeholder="请再次输入密码" :disabled="loginType.password"></el-input>
        </el-form-item>

        <el-form-item label="手机号码或邮箱地址" prop="account">
          <el-input v-model="registerForm.account" placeholder="请输入手机号码或邮箱地址" :disabled="loginType.password">
          </el-input>
        </el-form-item>

        <el-form-item prop="captcha">
          <el-input v-model="registerForm.captcha" placeholder="请输入算术答案" :disabled="loginType.password">
            <el-image :src="captchaUrl" style="vertical-align: middle; width: 148px; height: 36px; cursor: pointer;" title="点击更换" fit="fill" @click="clickImg" slot="suffix" ></el-image>
          </el-input>
        </el-form-item>
        <input type="hidden" v-model="uuid"/>

        <el-form-item label="验证码" prop="checkNumber">
          <el-input v-model="registerForm.checkNumber" placeholder="请输入验证码" :disabled="loginType.password">
            <template slot="append">
              <el-button plain :disabled="flag || loginType.password" @click="registerGetAuthCode" slot="suffix">{{ msg }}</el-button>
            </template>
          </el-input>
        </el-form-item>

        <el-row class="btn">
          <el-button class="loginBtn" type="primary" @click="startRegister" :disabled="loginType.password || isDisabled">注册</el-button>
          <el-button class="registerBtn" type="info" @click="goLogin" :disabled="loginType.password">返回登录</el-button>
        </el-row>

        <el-row class="regTip">
          <el-checkbox @change="handleDisabled"></el-checkbox>注册即代表您同意我们的<el-link type="primary" :underline="false" @click="goPrivacy">服务协议和隐私政策</el-link>
        </el-row>

      </el-form>
    </el-dialog>

    <div class="box retrievePwdBox" v-if="showLogin == 3">
      <div class="title">
        <span class="t1">
          重置密码
        </span>
        <div class="t2" @click="closeLogin()">
          X
        </div>
      </div>
      <el-divider></el-divider>
      <el-steps :active="active" finish-status="success">
        <el-step title="身份验证"></el-step>
        <el-step title="密码重置"></el-step>
        <el-step title="重置完成"></el-step>
      </el-steps>
      <div class="steps-content">
        <div class="form-content">
          <el-form v-if="active === 0" :model="accountForm" status-icon :rules="accountRule" ref="accountForm">
            <el-form-item prop="account">
              <el-input v-model="accountForm.account" placeholder="请输入手机号码或邮箱地址" :disabled="loginType.password"></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-input v-model="accountForm.captcha" placeholder="请输入算术答案" :disabled="loginType.password">
                <el-image :src="captchaUrl" style="vertical-align: middle; width: 148px; height: 36px; cursor: pointer;" title="点击更换" fit="fill" @click="clickImg" slot="suffix" ></el-image>
              </el-input>
            </el-form-item>
            <input type="hidden" v-model="uuid"/>
            <el-form-item prop="checkNumber">
              <el-input v-model="accountForm.checkNumber" placeholder="请输入验证码" :disabled="loginType.password">
                <template slot="append">
                  <el-button plain :disabled="flag2 || loginType.password" @click="getAuthCode" slot="suffix">{{ msg2 }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <el-form v-if="active === 1" ref="form" :model="form" :rules="resetPwdRule" :inline="true" label-width="100px">
            <el-form-item label="新密码" prop="newPassword">
              <el-input type="password" placeholder="请设置新密码" v-model="form.newPassword" :disabled="loginType.password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirm">
              <el-input type="password" placeholder="请确认新密码" v-model="form.confirm" :disabled="loginType.password"></el-input>
            </el-form-item>
          </el-form>
          <div v-if="active === 2" class="complete">
            <span>密码重置成功！</span>
          </div>
          <div v-if="active === 4" class="complete">
            <span>请重新登录！</span>
          </div>
        </div>
      </div>
      <div class="steps-action">
        <el-button v-if="active == 0" type="primary" @click="next">
          下一步
        </el-button>
        <el-button v-if="active == 1" type="primary" @click="onSubmit('form')">保存</el-button>
        <el-button v-if="active == 1" @click="$refs['form'].resetFields()">重置</el-button>
        <el-button
          v-if="active === 2"
          type="primary"
          @click="go_login()"
        >
          完成
        </el-button>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
  import {
    login,
    localLogin,
    localRegister,
    getUserLoginStatus,
    getValidCode,
    registerGetValidCode,
    validCode,
    resetPwd,
    captcha
  } from "@/api/user";
  import { Loading } from 'element-ui';
  import {setCookie} from "@/utils/cookieUtils";
  import {mapMutations} from "vuex";
  export default {
    name: "loginBox",
    data() {
      let validateAccount = (rule, value, callback) => {
        if (value === '') {
          return callback(new Error('手机号码或邮箱地址不能为空'))
        }
        let regEmail = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/
        let regMobile = /^1[3456789]\d{9}$/
        if (!regEmail.test(value) && !regMobile.test(value)) {
          return callback(new Error('手机号码或邮箱地址不正确'))
        }
        callback()
      }
      let validateConfirm = (rule, value, callback) => {
        if (value !== this.form.newPassword) {
          return callback(new Error('与新密码不一致!'))
        } else if (value.length < 5 || value.length > 20) {
          return callback(new Error('密码长度不符合要求'))
        } else {
          callback()
        }
      }
      return {
        dialogWidth: "30%",
        regDialogFormVisible: false,
        active: 0,
        flag: false,
        msg: '获取验证码',
        isDisabled: true,
        accountForm: {
          account: '',
          captcha: '',
          checkNumber: ''
        },
        flag2: false,
        msg2: '获取验证码',
        form: {
          newPassword: '',
          confirm: ''
        },
        loading: null,
        option: {
          fullscreen: true,
          lock: true
        },
        vueGjyWebUrl: process.env.VUE_GJY_WEB,
        showPasswordLogin: true, // 是否显示账号密码登录
        wechatOrCode: "", // 微信公众号登录二维码
        ticket: "", // 用户的票券
        // 显示登录页面
        showLogin: 1,
        isLogin: false,
        table: false,
        dialog: false,
        labelPosition: "right",
        loginForm: {
          account: "",
          password: ""
        },
        registerForm: {
          username: "",
          password: "",
          password2: "",
          account: "",
          checkNumber: ""
        },
        captchaUrl: '',
        uuid: '',
        // 登录类别
        loginType: {
          password: true,
          wechat: true,
          qq: true
        },
        loginRules: {
          account: [
            {required: true, message: '请输入手机号码或邮箱地址', trigger: 'blur'},
            { validator: validateAccount, trigger: 'blur' }
          ],
          password: [
            { required: true, message: "请输入密码", trigger: "blur" },
            { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
            { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
          ]
        },
        rules: {
          username: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
            { min: 2, message: "用户名长度大于等于 2 个字符", trigger: "blur" },
            { max: 20, message: "用户名长度不能大于 20 个字符", trigger: "blur" }
          ],
          password: [
            { required: true, message: "请输入密码", trigger: "blur" },
            { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
            { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
          ],
          password2: [
            { required: true, message: "请再次输入密码", trigger: "blur" },
            { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
            { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
          ],
          account: [
            {required: true, message: '请输入手机号码或邮箱地址', trigger: 'blur'},
            { validator: validateAccount, trigger: 'blur' }
          ],
          captcha: [
            {required: true, message: '请输入算术答案', trigger: 'blur'},
          ]
        },
        resetPwdRule: {
          newPassword: [
            { required: true, message: "请设置新密码", trigger: "blur" },
            { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
            { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
          ],
          confirm: [
            { required: true, message: '请确认新密码', trigger: 'blur' },
            { validator: validateConfirm, trigger: 'blur' }
          ]
        },
        accountRule: {
          account: [
            {required: true, message: '请输入手机号码或邮箱地址', trigger: 'blur'},
            { validator: validateAccount, trigger: 'blur' }
          ],
          captcha: [
            {required: true, message: '请输入算术答案', trigger: 'blur'},
          ]
        }
      };
    },
    components: {},
    mounted() {
      let that = this;
      // 屏幕自适应
      window.onresize = () => {
        return (() => {
          that.setSize()
        })()
      }
    },
    created() {
      this.setSize();
      this.setLoginTypeList()
    },
    methods: {
      ...mapMutations(['setUserInfo', 'setLoginState']),
      setSize() {
        let clientWidth = document.body.clientWidth
        if (clientWidth < 950) {
          this.dialogWidth = "95%";
        }
      },
      setLoginTypeList: function() {
        // 获取登录方式列表
        let webConfigData = this.$store.state.app.webConfigData
        if(webConfigData.loginTypeList != undefined) {
          let loginTypeList = JSON.parse(webConfigData.loginTypeList)
          for(let a=0; a<loginTypeList.length; a++) {
            switch (loginTypeList[a]) {
              case "1": {
                this.loginType.password = false
              } break;
              case "2": {
                this.loginType.wechat = false
              } break;
              case "3": {
                this.loginType.qq = false
              } break;
              default: {
                console.log("登录方式设置有误！！")
              }
            }
          }
        }
      },
      startLogin: function () {
        this.$refs.loginForm.validate((valid) => {
          console.log("开始校验", valid)
          if(!valid) {
            console.log('校验失败')
            return;
          } else {
            let params = {};
            params.account = this.loginForm.account;
            params.password = this.loginForm.password;
            params.isRememberMe = 1;
            localLogin(params).then(response => {
              if (response.code == this.$ECode.SUCCESS) {
                // 跳转到首页
                // location.replace(this.vueGjyWebUrl + "/#/?token=" + response.data)
                setCookie("token", response.data, 7)
                window.location.reload()
              } else {
                this.$message({
                  type: "error",
                  message: response.data,
                  offset: 100
                })
              }
            });
          }
        })
      },
      registerGetAuthCode () {
        this.$refs['registerForm'].validate(async (valid) => {
          if (valid) {
            const that = this
            that.flag = true
            let time = 60
            let timer = null
            timer = setInterval(function () {
              if (time === 0) {
                that.msg = '重新获取验证码';
                that.flag = false;
                clearInterval(timer);
              } else {
                that.msg = time + '秒后重新获取';
                time--;
              }
            }, 1000)
            let params = {};
            params.account = that.registerForm.account;
            params.captcha = that.registerForm.captcha;
            params.uuid = that.uuid;
            registerGetValidCode(params).then(response => {
              if (response.code != this.$ECode.SUCCESS) {
                this.$message({
                  type: "error",
                  message: response.data,
                  offset: 100
                })
                that.clickImg();
                clearInterval(timer);
                that.flag = false;
              }
            })
          }
        })
      },
      startRegister: function () {
        this.$refs.registerForm.validate((valid) => {
          if(!valid) {
            console.log('校验失败')
            return;
          } else {
            let passWord = this.registerForm.password;
            let passWord2 = this.registerForm.password2;
            if(passWord != passWord2) {
              this.$message({
                type: "success",
                message: "两次密码不一致",
                offset: 100
              })
              return;
            }
            if(this.registerForm.checkNumber == "") {
              this.$message({
                type: "warning",
                message: "验证码不能为空",
                offset: 100
              })
              return;
            }
            let params = {};
            params.username = this.registerForm.username;
            params.password = this.registerForm.password;
            params.account = this.registerForm.account;
            params.code = this.registerForm.checkNumber;
            localRegister(params).then(response => {
              if (response.code == this.$ECode.SUCCESS) {
                this.$message({
                  type: "success",
                  message: response.data,
                  offset: 100
                })
                // 打开登录页面
                this.goLogin();
              } else {
                this.$message({
                  type: "error",
                  message: response.data,
                  offset: 100
                })
              }
            });
          }
        })
      },
      handleDisabled: function(value) {
        if(value == true) {
          this.isDisabled = false
        } else {
          this.isDisabled = true
        }
      },
      goLogin: function () {
        this.showLogin = 1;
      },
      goRegister: function () {
        this.registerForm.username="";
        this.registerForm.password="";
        this.registerForm.password2="";
        this.registerForm.account="";
        this.registerForm.checkNumber="";
        this.showLogin = 2;
        this.isDisabled = true;
        this.regDialogFormVisible = true;
        this.clickImg();
      },
      clickImg(){
        captcha().then(response => {
          if (response.code == this.$ECode.SUCCESS) {
            this.captchaUrl = response.data.img;
            this.uuid = response.data.uuid;
          }
        });
      },
      forgetPwd: function() {
        this.showLogin = 3;
        this.clickImg();
      },
      userInfoStatus: function () {
        getUserLoginStatus().then(response => {
            console.log("获取用户状态", response)
        });
      },
      goAuth: function (source) {
        // 记录跳转地址，后续登录后做跳转到此页面
        setCookie("redirectUrl", this.$route.path, 1);
        this.loading = Loading.service({
          lock: true,
          text: '加载中……',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let params = new URLSearchParams();
        params.append("source", source);
        login(params).then(response => {
          if (response.code == this.$ECode.SUCCESS) {
            window.location.href = response.data.url
          }
        });
      },
      closeLogin: function() {
        this.$emit("closeLoginBox", "");
      },
      closeRegBox: function() {
        this.closeLogin();
        this.regDialogFormVisible = false;
      },
      next () {
        this.$refs['accountForm'].validate(async (valid) => {
          if (valid) {
            if(this.accountForm.checkNumber == "") {
              this.$message({
                type: "warning",
                message: "验证码不能为空",
                offset: 100
              })
              return;
            }

            let params = {};
            params.account = this.accountForm.account;
            params.code = this.accountForm.checkNumber;
            validCode(params).then(response => {
              if (response.code == this.$ECode.SUCCESS) {
                if (response.data) {
                  this.active++
                } else {
                  this.$message({
                    type: "warning",
                    message: "验证码不正确",
                    offset: 100
                  })
                }
              }
            })
          }
        })
      },
      goPrivacy() {
        this.closeRegBox();
        this.$router.push('/datapolicy')
      },
      go_login () {
        this.active += 2
        window.location.reload()
      },
      getAuthCode () {
        this.$refs['accountForm'].validate(async (valid) => {
          if (valid) {
            const that = this
            that.flag2 = true
            let time = 60
            let timer = null
            timer = setInterval(function () {
              if (time === 0) {
                that.msg2 = '重新获取验证码'
                that.flag2 = false
                clearInterval(timer)
              } else {
                that.msg2 = time + '秒后重新获取'
                time--
              }
            }, 1000)
            let params = {};
            params.account = that.accountForm.account;
            params.captcha = that.accountForm.captcha;
            params.uuid = that.uuid;
            getValidCode(params).then(response => {
              if (response.code != this.$ECode.SUCCESS) {
                this.$message({
                  type: "error",
                  message: response.data,
                  offset: 100
                })
                that.clickImg();
                clearInterval(timer)
                that.flag2 = false
              }
            })
          }
        })
      },
      onSubmit (formName) {
        const that = this
        this.$refs[formName].validate(valid => {
          if(!valid) {
            console.log('校验失败')
            return;
          } else {
            let params = {};
            params.account = that.accountForm.account;
            params.password = that.form.newPassword;
            params.code = that.accountForm.checkNumber;
            resetPwd(params).then(response => {
              if (response.code == this.$ECode.SUCCESS) {
                this.active++
              } else {
                this.$message({
                  type: "error",
                  message: response.data,
                  offset: 100
                })
              }
            })
          }
        })
      }
    }
  };
</script>

<style>
  .box {
    width: 380px;
    height: 400px;
    background: white;
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 101; /* 要比遮罩层大 */
  }

  .box .title {
    height: 38px;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 48px;
  }
  .box .title .t2 {
    font-size: 16px;
    float: right;
    margin-right: 6px;
    margin-top: -6px;
    cursor: pointer;
  }

  .box .el-divider--horizontal {
    margin: 12px 0;
  }

  .box .el-form-item__label {
    margin-left: 10px;
    font-size: 16px;
  }

  .box .el-input__inner {
    margin-left: 10px;
    width: 95%;
  }

  .box .btn {
    text-align: center;
  }

  .box .loginBtn {
    width: 40%;
  }

  .box .registerBtn {
    width: 40%;
  }

  .btn {
    text-align: center;
  }

  .loginBtn {
    width: 40%;
  }

  .registerBtn {
    width: 40%;
  }

  .elRow {
    margin-top: 15px;
    text-align: center;
  }

  .loginTip {
    margin-top: 10px;
    font-size: 14px;
    text-align: center;
    color: #bababa;
  }

  .regTip {
    margin-top: 10px;
    font-size: 14px;
    text-align: center;
    color: #bababa;
    white-space: nowrap;
  }

  /* 遮罩层 */
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
  }

  .retrievePwdBox {
    height: 460px;
    /* background-image: url("../../assets/img/back.jpg");*/
  }

  .steps-action {
    margin-top: 24px;
    text-align: center;
  }

  .steps-content {
    margin-top: 20px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;

    text-align: center;
    padding-top: 40px;
    padding-bottom: 20px;
  }

  .form-content{
    margin-left: 5%;
    margin-right: 5%;
  }

  .complete {
    padding-top: 50px;
    padding-bottom: 60px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #ebebeb;
    font-size: 22px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginBox/index.vue